import React from "react";
import { TrendingUp, GaugeCircle, Search, Workflow, Users } from "lucide-react";
import { SectionContainer, SectionLabel, SectionHeading, SectionLead } from "./SectionPrimitives";

const BENEFITS = [
  { icon: TrendingUp, kpi: "+38%", label: "Sichtbarkeit", desc: "Mehr Reichweite in Google Vehicle Ads und organischer Suche." },
  { icon: GaugeCircle, kpi: "96%", label: "Feed-Qualität", desc: "Validierte Pflichtfelder, weniger Disapprovals, stabile Live-Quote." },
  { icon: Search, kpi: "+62%", label: "Indexierte Seiten", desc: "Pro Fahrzeug eine indexierbare SEO-Landingpage mit Schema-Daten." },
  { icon: Workflow, kpi: "−72%", label: "Manueller Aufwand", desc: "Pflege, Korrektur und Resubmission laufen automatisiert im Hintergrund." },
  { icon: Users, kpi: "2.4×", label: "Qualifizierte Leads", desc: "Mehr Klicks aus relevantem Such-Intent, höhere Anfragenqualität." },
];

export default function Nutzen() {
  return (
    <SectionContainer id="nutzen" className="bg-white">
      <div className="grid lg:grid-cols-12 gap-12 items-end">
        <div className="lg:col-span-7">
          <SectionLabel number="/ 04" label="Nutzen / Ergebnisse" />
          <SectionHeading>Sichtbarkeit, die sich rechnen lässt.</SectionHeading>
        </div>
        <div className="lg:col-span-5">
          <p className="text-base text-slate-600 leading-relaxed">
            Messbare Effekte über alle Standorte hinweg — basierend auf realer Projektarbeit
            mit Händlern und Händlergruppen im DACH-Raum.
          </p>
        </div>
      </div>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-px bg-slate-200 border border-slate-200 rounded-lg overflow-hidden">
        {BENEFITS.map((b, idx) => {
          const Icon = b.icon;
          return (
            <div key={b.label} data-testid={`nutzen-${idx}`} className="bg-white p-6 sm:p-7">
              <Icon className="size-5 text-cyan-600" />
              <p className="mt-5 font-display text-3xl font-bold text-slate-900 tabular-nums">{b.kpi}</p>
              <p className="mt-1 label-mono text-slate-500">{b.label}</p>
              <p className="mt-4 text-sm text-slate-600 leading-relaxed">{b.desc}</p>
            </div>
          );
        })}
      </div>
    </SectionContainer>
  );
}
